import React from 'react';
import EditExpenseButton from "./components/buttons/EditExpenseButton";
import {FleetExpensesModelAny} from "../../../models/FleetExpenses/FleetExpensesModel";
import {isFleetExpenseOfType} from "./config";
import AddExpenseButton from "./components/buttons/AddExpenseButton";
import DeleteExpenseButton from "./components/buttons/DeleteExpenseButton";

export type FleetExpenseActionsProps = {
  entity: FleetExpensesModelAny;
};

const FleetExpenseActions = (props: FleetExpenseActionsProps) => {
  if (isFleetExpenseOfType(props.entity, 'driver')) {
    return null;
  }

  return (
    <div style={{ boxSizing: 'content-box' }}>
      { isFleetExpenseOfType(props.entity, 'expense') && (
        <div className={'fleet-actions'} style={{ paddingLeft: '16px' }}>
          <EditExpenseButton expense={props.entity} />
          <DeleteExpenseButton expense={props.entity} />
        </div>
      )}
      { isFleetExpenseOfType(props.entity, 'spending-type') && (
        <div className={'fleet-actions'} style={{ paddingLeft: '8px' }}>
          <AddExpenseButton expense={props.entity} />
        </div>
      )}
      { isFleetExpenseOfType(props.entity, 'tc') && (
          <div className={'fleet-actions'}>
            <AddExpenseButton expense={props.entity} />
          </div>
        )}
    </div>
  );
};

export default FleetExpenseActions;